import { render, staticRenderFns } from "./BenefiariesSelector.vue?vue&type=template&id=61d143c0"
import script from "./BenefiariesSelector.vue?vue&type=script&lang=js"
export * from "./BenefiariesSelector.vue?vue&type=script&lang=js"
import style0 from "./BenefiariesSelector.vue?vue&type=style&index=0&id=61d143c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports